import { Link } from "react-router-dom";
import styles from "./Footer.module.scss";
import { ReactComponent as MailIcon } from "monoff-web-design-system/src/img/icon/24/Email, Fill=True.svg";
import { ReactComponent as LocationIcon } from "monoff-web-design-system/src/img/icon/24/Location Fill=True.svg";
import { ReactComponent as LineIcon } from "../../Img/footer/Line.svg";
import { ReactComponent as LinkedInIcon } from "monoff-web-design-system/src/img/icon/24/social_linkedin.svg";
import { ReactComponent as InstagramIcon } from "monoff-web-design-system/src/img/icon/24/social_instagram.svg";
import { ReactComponent as YoutubeIcon } from "monoff-web-design-system/src/img/icon/24/social_youtube.svg";
import { ReactComponent as GooglePlayIcon } from "monoff-web-design-system/src/img/icon/24/googleplay.svg";
import { ReactComponent as IosIcon } from "monoff-web-design-system/src/img/icon/24/ios.svg";
import { ReactComponent as LogoIcon } from "../../Img/logo/logo-white.svg";
import React, { SetStateAction } from "react";
import classNames from "classnames";
export default function Footer({
  isSidebar,
  setIsSelect,
}: {
  isSidebar: boolean;
  setIsSelect: React.Dispatch<SetStateAction<string>>;
}) {
  const onClick = (e: any): void => {
    const target = e.target as HTMLElement;
    setIsSelect(target.innerHTML);
  };
  return (
    <div className={styles.container}>
      <div className={styles.menuAndLink}>
        <div className={styles.menuContainer}>
          <div className={styles.contentsContainer}>
            <LogoIcon className={styles.logo} />
            <ul className={styles.menuList}>
              <Link
                to="/culture"
                onClick={onClick}
                className={classNames({
                  "label-kr-L": true,
                })}
              >
                문화와 복지
              </Link>
              <Link
                to="/position"
                onClick={onClick}
                className={classNames({
                  "label-kr-L": true,
                })}
              >
                채용 중인 직무
              </Link>
            </ul>
          </div>
        </div>

        <div className={styles.snsIconContainer}>
          <a
            href="https://www.linkedin.com/company/mondayoff-inc/mycompany/"
            target="_blank"
            rel="noreferrer"
          >
            <LinkedInIcon />
          </a>
          <a
            href="https://www.instagram.com/mondayoff_official/"
            target="_blank"
            rel="noreferrer"
          >
            <InstagramIcon />
          </a>
          <a
            href="https://www.youtube.com/channel/UCgYNSY4mEvtTjGUG7L56k6w"
            target="_blank"
            rel="noreferrer"
          >
            <YoutubeIcon />
          </a>
          <a
            href="https://apps.apple.com/us/developer/mondayoff/id1448226898"
            target="_blank"
            rel="noreferrer"
          >
            <IosIcon />
          </a>
          <a
            href="https://play.google.com/store/apps/developer?id=MondayOFF&hl=ko&gl=US"
            target="_blank"
            rel="noreferrer"
          >
            <GooglePlayIcon />
          </a>
        </div>
      </div>
      <div className={styles.companyInfo}>
        <div className={styles.email}>
          <MailIcon />{" "}
          <p
            className={classNames({
              "body-kr-M": true,
            })}
          >
            people@mondayoff.me
          </p>
        </div>
        <div className={styles.location}>
          <LocationIcon />
          <p
            className={classNames({
              "body-kr-M": true,
            })}
          >
            14F, 465, Bongeunsa-ro, Gangnam-gu, Seoul, Republic of Korea
          </p>
        </div>
      </div>
      <div className={styles.termContainer}>
        <p
          className={classNames({
            "body-kr-S": true,
          })}
        >
          ©2021 MondayOFF
        </p>
        <LineIcon />
        <a
          href="https://mondayoff.me/privacyPolicy.html"
          target="_blank"
          rel="noreferrer"
          className={classNames({
            "body-kr-S": true,
          })}
        >
          Privacy
        </a>
      </div>
    </div>
  );
}
